import M from 'materialize-css/dist/js/materialize';
import i18n from '../i18n';
import { DEFAULT_AUDIOS } from './constantsAudios';
import { getVision } from '../../src/services/auth';
import { ENUMS, PLANTS, VISIONS } from './constants';
import { decodeJwt } from 'jose';

export const getLocalIP = async () => {
    const peerConnection = new RTCPeerConnection();
    peerConnection.createDataChannel('');

    peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
            const candidate = event.candidate.candidate;
            const ipMatch = candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3})/);
            if (ipMatch) {
                peerConnection.close();
                return ipMatch[1];
            }
        }
    };

    const offer = await peerConnection.createOffer();
    await peerConnection.setLocalDescription(offer);
};


export const getNumberValueOrDefault = (valueVerify, defaultValue = 0) => {
    if (valueVerify === undefined || valueVerify === null || isNaN(valueVerify)) {
        return defaultValue
    }

    return Number(valueVerify)
}

export const groupByNew = (list, key) => {
    if (!list || list.length === 0) return [];

    const map = new Map();

    list.forEach(item => {
        const keyValue = item[key];
        if (!map.has(keyValue)) {
            map.set(keyValue, []);
        }
        map.get(keyValue).push(item);
    });

    return Array.from(map, ([k, v]) => ({ key: k, value: v }));
};

export const groupBy = (listToGroup, key) => {
    return !isNullOrEmpty(listToGroup) ? listToGroup.reduce((prev, row) => {
        const group = prev.find((i) => i.key === row[key]);
        if (group) {
            group.value = [...group.value, row];
        } else {
            prev.push({ key: row[key], value: [row] });
        }
        return prev;
    }, []) : [];
};

export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const convertToDecimal = (value, decimalLimit) => {
    if (!isNullOrEmpty(value) && (value.toString().includes(".") || value.toString().includes(","))) {
        return convertToSeparator((Math.floor(parseFloat(value) * 100) / 100).toFixed(decimalLimit || 2));
    }
    return value;
}

export const stringFormat = (template, ...args) => {
    return template.replace(/{([0-9]+)}/g, function (match, index) {
        return typeof args[index] === 'undefined' ? match : args[index];
    });
}

export const convertToSeparator = (value) => {
    if (!isNullOrEmpty(value)) {
        const culture = localStorage.getItem('i18nextLng');
        return value.toLocaleString(culture || 'pt-BR');
    }
    return value;
}

export const convertToUppercase = (e) => {
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.setSelectionRange(start, end);
}

export const convertToFloat = (value, options) => {
    if (value && value !== '' && options.decimalSymbol !== '.') {
        value = value.replace(options.thousandsSeparatorSymbol, '');
        value = value.replace(options.decimalSymbol, '.');

        value = parseFloat(value).toFixed(options.decimalLimit);
    }
    return value;
};

export const leftPad = (value, totalWidth, paddingChar) => {
    const length = totalWidth - value.toString().length + 1;
    return Array(length).join(paddingChar || '0') + value;
};

export const rightPad = (value, totalWidth, paddingChar) => {
    const length = totalWidth - value.toString().length + 1;
    return value + Array(length).join(paddingChar || '0');
};

export const formatData = (item) => {
    if (item && item !== '') {
        const data = new Date(item);
        const culture = localStorage.getItem('i18nextLng');
        return data.toLocaleString(culture || 'pt-BR');
    }
    return '';
};

export const formatJson = (jsonText) => {
    try {
        return JSON.stringify(JSON.parse(jsonText), null, 2);

    } catch (error) {
        console.error("JSON inválido");
        return jsonText;
    }
}

export const updateTextFields = () => {
    M.updateTextFields();
};

export const showMessageToast = (options) => {
    M.toast(options);
};

export const makeEnum = (enumObject) => {
    const all = [];
    for (const key in enumObject) {
        all.push(enumObject[key]);
    }
    return all;
}

export const autoFocus = (id) => {
    const input = document.getElementById(id);
    if (input) {
        input.focus();
    }
}

export const showMessageToastCustom = (title, message, displayTime, icon, bgColor, textColorClass, titleColorClass) => {
    if (message && message.includes("Network Error")) {
        message = translate('general.timeout');
    }

    const messageShow = `<div class="${textColorClass || 'second-text-color'}">                                                                
                            <i class="title ${icon || 'mdi mdi-alert'}"></i>                            
                            <strong><span class="title ${titleColorClass || 'sixth-text-color'}">${title}</span></strong>                            
                            <div class="col s12" style={{ marginLeft: '5px' }}>${message}</div>                             
                        </div>`;
    M.toast({ html: messageShow, classes: bgColor || 'white', displayLength: displayTime || 4000 });
};

if (typeof window !== 'undefined') {
    window.showMessageToastCustom = showMessageToastCustom;
}

export const validateToken = (token) => {
    if (!isNullOrEmpty(token)) {
        const decoded = decodeToken(token);
        const expires = new window.Date((decoded.exp * 1000));
        return formatData(expires);
    }
}

export const decodeToken = (token) => {
    if (!isNullOrEmpty(token)) {
        const decoded = decodeJwt(token);  // Decodifica o payload do token
        return decoded;
    }
}

export const newObj = (target) => {
    let dataObj = {};
    Object.assign(dataObj, target);
    return dataObj;
}

export const newObjArray = (targetArray) => {
    let dataObjArray = [];
    Object.assign(dataObjArray, targetArray);
    return dataObjArray;
}

export const translate = (field, fileTranslation, params) => {
    if (field && field.toString().includes("line-picking") && field.toString().includes("CIM")
        && (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
        field = field.replace('CIM', 'CIMFiasa');
    }

    if (fileTranslation) {
        if (params) {
            return i18n.t(`${fileTranslation}:${field}`, params);
        } else {
            return i18n.t(`${fileTranslation}:${field}`);
        }
    } else if (params) {
        return (i18n.t(field, params));
    } else {
        return (i18n.t(field));
    }
};

export const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
};

export const closeCollapsible = (id) => {
    var elemente = document.getElementById(id);
    if (elemente && elemente.M_Collapsible) {
        elemente.M_Collapsible.close()
    }
};

export const openCollapsible = (id) => {
    var elemente = document.getElementById(id);
    if (elemente && elemente.M_Collapsible) {
        elemente.M_Collapsible.open()
    }
};

export const gerarCSV = (title, as) => {
    try {
        let csvContent = "data:text/csv;charset=utf-8,";
        for (let index = 0; index < as.length; index += 1) {
            const rowArray = as[index];
            if (index === 0) {
                const header = Object.keys(rowArray).map((key) => [key]);
                csvContent += header.join(";") + "\r\n";
            }

            const arr = Object.keys(rowArray).map((key) => {
                if (rowArray[key] && rowArray[key].length > 15 && !isNaN(rowArray[key])) {
                    return [`'${rowArray[key]}`];
                }
                return [rowArray[key]];
            });
            csvContent += arr.join(";").toString() + "\r\n";
        }

        const link = document.createElement("a");
        link.setAttribute("href", encodeURI(csvContent));
        link.setAttribute("download", `${title}${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.log(error);
    }
}

export const enumText = (enumetator, value) => {
    const objEnum = value !== undefined && enumetator !== undefined && typeof enumetator === 'object' ? Object.entries(enumetator).find((i) => i[1].value.toString() === value.toString()) : undefined;
    if (objEnum) {
        return objEnum[1].text;
    } else {
        return '';
    }
};

export const enumColor = (enumetator, value) => {
    const objEnum = !isNullOrEmpty(value) && enumetator !== undefined && typeof enumetator === 'object' ? Object.entries(enumetator).find((i) => i[1].value.toString() === value.toString()) : undefined;
    if (objEnum) {
        return objEnum[1].color;
    } else {
        return '#000';
    }
};


export const msgAppHandler = (e) => {
    if (e.data.indexOf('messageType') >= 0) {
        const msg = JSON.parse(e.data);
        if (msg.messageType === 'labelPrinted') {
            if (!msg.success) {
                showMessageToastCustom(translate('warning', 'general'), msg.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                showMessageToastCustom(translate('sucess', 'general'), msg.message, 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            }
        }
    }
}

export const convertBase64ToByte = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
};

export const downloadFile = (data, fileName, contentType, convertToByte) => {
    if (navigator.userAgent !== 'logisticspwa') {
        if (convertToByte) {
            data = convertBase64ToByte(data);
        }
        const blob = new Blob([data], { type: contentType, filename: fileName });
        const url = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');

        tempLink.href = url;
        tempLink.download = fileName;
        document.body.append(tempLink);
        tempLink.click();
        window.URL.revokeObjectURL(url);
        tempLink.remove();
    } else {
        const msg = {
            messageType: 'download',
            value: data,
            name: fileName,
            type: contentType,
            msgSuccess: translate('general.download-file.successMobile', null, fileName),
            msgError: translate('general.download-file.errorMobile', null, fileName)
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(msg), '*');
    }
};

export const networkConnectionOffline = () => {
    // eslint-disable-next-line max-len
    showMessageToastCustom(translate('warning', 'general'), translate('validations.check-connection'), 8000, 'mdi mdi-alert-circle-outline red-text');
    const lang = language();

    switch (lang) {
        case 'en':
            playAudio(DEFAULT_AUDIOS.checkConnection.english);
            break;
        case 'it':
            playAudio(DEFAULT_AUDIOS.checkConnection.italian);
            break;
        case 'es-AR':
            playAudio(DEFAULT_AUDIOS.checkConnection.spanish);
            break;
        default:
            playAudio(DEFAULT_AUDIOS.checkConnection.portuguese);
            break;
    }
};

export const playAudio = (outputAudio, callback) => {
    const srcAudio = `data:audio/mpeg;base64,${outputAudio}`;
    if (navigator.userAgent === 'logisticspwa') {
        const msg = { messageType: 'playsound', value: srcAudio };
        const content = window.ReactNativeWebView;
        content.postMessage(JSON.stringify(msg));
        if (callback) {
            callback();
        }
    } else {
        const audio = new Audio(srcAudio);
        audio.autoplay = false;
        audio.oncanplay = (ev) => {
            ev.currentTarget.play().then(() => {
            });
        };

        audio.onended = () => {
            if (callback) {
                callback();
            }
        };
    }
};

export const isWebMobile = () => {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    }
    else {
        return false;
    }
}
export const testPrint = (printerAddress, printerManufacturer) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify(
                {
                    messageType: 'testPrint',
                    printerAddress: printerAddress,
                    dataToPrint: "",
                    printerManufacturer: parseInt(printerManufacturer || 0)
                }));
        }
    } else {
        showMessageToastCustom(translate('warning', 'general'), translate('validations.service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
    }
}

export const testPrintData = (printerAddress, data, printerManufacturer) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify(
                {
                    messageType: 'testPrint',
                    printerAddress: printerAddress,
                    dataToPrint: data,
                    printerManufacturer: printerManufacturer
                }));
        }
    } else {
        showMessageToastCustom(translate('warning', 'general'), translate('validations.service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
    }
}


export const openCloseScanner = (valueOpenClose, markerCodeBar, sizeCode) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'qrcode', value: valueOpenClose, showMarkerCodeBar: markerCodeBar, sizeCode: sizeCode }));
        }
    } else if (valueOpenClose !== 'close') {
        showMessageToastCustom(translate('warning', 'general'), translate('validations.service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
    }
};

export const openCloseCamera = (valueOpenClose) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'cameraPicture', value: valueOpenClose }));
        }
    } else if (valueOpenClose !== 'close') {
        showMessageToastCustom(translate('warning', 'general'), translate('validations.service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
    }
};

export const hideKeyboardDevice = () => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'keyboard', value: 'hide' }));
        }
    }
};

export const sendPushNotification = (notification) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'PushNotification', value: notification }));
        }
    }
};

export const sendPushNotificationShipmentTracking = (notification) => {
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'PN-ShipmentTracking', value: notification }));
        }
    }
};

const configsArray = (configItems) => {
    return configItems.reduce((obj, item) => {
        obj[item.key] = item.value
        return obj
    }, {});
};

export const configs = (moduleId, configItems) => {
    if (configItems && configItems.length > 0) {
        const items = configItems.filter((e) => e.moduleId === moduleId);
        return configsArray(items);
    }
    return {}
}

export const objPagination = (data) => {
    if (data) {
        // eslint-disable-next-line radix
        const pages = parseInt(data.length / 10);
        return {
            hasNextPage: pages > 1,
            hasPreviousPage: false,
            indexFrom: 0,
            items: data,
            pageIndex: 0,
            pageSize: 10,
            totalCount: data.length,
            totalPages: pages
        };
    } else {
        return {
            hasNextPage: 1,
            hasPreviousPage: false,
            indexFrom: 0,
            items: data,
            pageIndex: 0,
            pageSize: 10,
            totalCount: 0,
            totalPages: 0
        };
    }
};

export const todayDate = () => {
    const data = new Date();
    let mes = (data.getMonth() + 1).toString();
    mes = mes.length === 1 ? '0' + mes : mes;
    return data.getFullYear().toString() + '-' + mes + '-' + data.getDate().toString()
};


export const formatDate = (date) => {
    if (isNullOrEmpty(date)) {
        return ""
    }

    let d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
}

export const formatDateToPtbr = (value) => {
    if (isNullOrEmpty(value)) {
        return ""
    }

    let date = value.split('-');
    return `${date[2].substring(0, 2)}/${date[1]}/${date[0]}`;
}

export const validateNumber = (value) => {
    const regex = /^[0-9]+$/
    return regex.test(value);
}

export const handleFormKeyDown = (event, callback) => {
    if ((event.key === 'Enter' || event.keyCode === 13) && callback) {
        event.preventDefault();
        callback();
    }
}

export const stringEmpty = () => { return ""; }

export const isNullOrEmpty = (value) => ((value === null || value === undefined || value === '') || false);

export const language = () => localStorage.getItem('i18nextLng');

export const checkOriginInternal = (window) => window.location.origin.indexOf('-internal.') >= 0;

export const checkOriginNonProd = (window) => window.location.origin.indexOf('-nonprod.') >= 0 || window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('192.168') >= 0;

export const getPathApp = (window) => (checkOriginNonProd(window) === true ? process.env.REACT_APP_NONPROD_PATH : process.env.REACT_APP_PROD_PATH);

export const getSystemId = (window) => (checkOriginNonProd(window) === true ? process.env.REACT_APP_NONPROD_SYSTEM_ID : process.env.REACT_APP_PROD_SYSTEM_ID);

export const getApiKeyLogistics = (window) => (checkOriginNonProd(window) === true ? process.env.REACT_APP_NONPROD_API_KEY_LOGISTICS : process.env.REACT_APP_PROD_API_KEY_LOGISTICS);

export const getUrlByOrigin = (url, window) => {
    const internal = checkOriginInternal(window);
    // when external, replace baseURL removing tag 'internal'
    if (!internal && url && url.indexOf('-internal') >= 0) {
        url = url.replace('-internal', '');
    }
    return url;
};

export const isLatitude = (lat) => {
    return isFinite(lat) && (lat < -90 || lat > 90);
}

export const isLongitude = (lng) => {
    return isFinite(lng) && (lng < -180 || lng > 180);
}

export const parseParams = (params) => {
    const keys = Object.keys(params);
    let options = '';

    keys.forEach((key) => {
        const paramsKey = params[key];
        const isParamTypeObject = typeof params[key] === 'object';
        const isParamTypeArray = isParamTypeObject && paramsKey?.length >= 0;

        if (!isParamTypeObject && paramsKey) {
            options += `${key}=${params[key]}&`;
        }

        if (isParamTypeObject && isParamTypeArray) {
            paramsKey.forEach((element) => {
                options += `${key}=${element}&`;
            });
        }
    });

    return options ? options.slice(0, -1) : options;
};

export const validationLatitude = (inputRef) => {
    if (inputRef) {
        if (isLatitude(inputRef.value)) {
            inputRef.classList.add('invalid');
            let element = inputRef.parentElement.getElementsByClassName('helper-text')[0];
            if (element !== null && element !== undefined) {
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', translate('validations.latitude-validate', 'general'));
                inputRef.parentElement.appendChild(element);
                return false;
            } else {
                element = document.createElement('span');
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', translate('validations.latitude-validate', 'general'));
                inputRef.parentElement.appendChild(element);
                return false;
            }
        } else {
            inputRef.classList.remove('invalid');
            const elRemove = inputRef.parentElement.getElementsByClassName('helper-text')[0];
            if (elRemove !== null && elRemove !== undefined) {
                inputRef.parentElement.removeChild(elRemove);
            }
            return true;
        }
    }
};

export const validationLongitude = (inputRef) => {
    if (inputRef) {
        if (isLongitude(inputRef.value)) {
            inputRef.classList.add('invalid');
            let element = inputRef.parentElement.getElementsByClassName('helper-text')[0];
            if (element !== null && element !== undefined) {
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', translate('validations.longitude-validate', 'general'));
                inputRef.parentElement.appendChild(element);
                return false;
            } else {
                element = document.createElement('span');
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', translate('validations.longitude-validate', 'general'));
                inputRef.parentElement.appendChild(element);
                return false;
            }
        } else {
            inputRef.classList.remove('invalid');
            const elRemove = inputRef.parentElement.getElementsByClassName('helper-text')[0];
            if (elRemove !== null && elRemove !== undefined) {
                inputRef.parentElement.removeChild(elRemove);
            }
            return true;
        }
    }
};

export const validateEmail = (email) => {
    var valid = true;

    if (email.indexOf('@') === -1) {
        valid = false;
    } else {
        var parts = email.split('@');
        var domain = parts[1];

        if (domain.indexOf('.') === -1) {
            valid = false;
        } else {
            var domainParts = domain.split('.');
            var ext = domainParts[1];
            if (ext.length > 4 || ext.length < 2) {
                valid = false;
            }
        }
    }
    return valid;
}

export const getUrlP224FiasaApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_P224FIASA_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_P224FIASA_API, window));

export const getUrlP216FptApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_P216FPT_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_P216FPT_API, window));

export const getUrlP232FiasaApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_P232FIASA_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_P232FIASA_API, window));

export const getUrlLogisticsApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_LOGISTICS_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_LOGISTICS_API, window));

export const getUrlPhysicalConfirmationApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_PHYSICAL_CONFIRMATION_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_PHYSICAL_CONFIRMATION_API, window));

export const getUrlSecurityApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_SECURITY_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_SECURITY_API, window));

export const getUrlPlantApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_PLANT_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_PLANT_API, window));

export const getUrlInventoryApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_INVENTORY_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_INVENTORY_API, window));

export const getUrlLineInventoryApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_LINE_INVENTORY_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_LINE_INVENTORY_API, window));

export const getUrlAEApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_AE_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_AE_API, window));

export const getUrlMdrApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_MDR_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_MDR_API, window));

export const getUrlExpeditionApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_EXPEDITION_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_EXPEDITION_API, window));

export const getUrlCommunicationApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_COMMUNICATION_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_COMMUNICATION_API, window));

export const getUrlLocationApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_LOCATION_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_LOCATION_API, window));

export const getUrlConfigApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_CONFIG_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_CONFIG_API, window));

export const getUrlMessageApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_MESSAGE_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_MESSAGE_API, window));

export const getUrlShipmentApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_SHIPMENT_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_SHIPMENT_API, window));

export const getUrlShipmentLogisticsApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_SHIPMENT_LOGISTICS_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_SHIPMENT_LOGISTICS_API, window));

export const getUrlVolumeApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_VOLUME_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_VOLUME_API, window));

export const getUrlRepositoryApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_REPOSITORY_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_REPOSITORY_API, window));

export const getUrlPartNumberApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_PARTNUMBER_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_PARTNUMBER_API, window));

export const getUrlTruckKanbanApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_TRUCK_KANBAN_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_TRUCK_KANBAN_API, window));

export const getUrlLogisticsS3 = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_BUCKET_S3, window) : getUrlByOrigin(process.env.REACT_APP_PROD_BUCKET_S3, window));

export const getUrlStockApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_STOCK_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_STOCK_API, window));

export const getUrlSupplierApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_SUPPLIER_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_SUPPLIER_API, window));

export const getUrlContainerApi = (window) => (
    checkOriginNonProd(window) === true ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_CONTAINER_API, window) : getUrlByOrigin(process.env.REACT_APP_PROD_URL_CONTAINER_API, window));


// -------------------------------------------------WebSocket----------------------------------------------------------
export const getUrlInventoryApiWebSocket = (window) => (
    checkOriginNonProd(window) === true
        ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_INVENTORY_API_WEBSOCKET, window)
        : getUrlByOrigin(process.env.REACT_APP_PROD_URL_INVENTORY_API_WEBSOCKET, window));

export const getUrlExpeditionApiWebSocket = (window) => (
    checkOriginNonProd(window) === true
        ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_EXPEDITION_API_WEBSOCKET, window)
        : getUrlByOrigin(process.env.REACT_APP_PROD_URL_EXPEDITION_API_WEBSOCKET, window));

export const getUrlLocationApiWebSocket = (window) => (
    checkOriginNonProd(window) === true
        ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_LOCATION_API_WEBSOCKET, window)
        : getUrlByOrigin(process.env.REACT_APP_PROD_URL_LOCATION_API_WEBSOCKET, window));

export const getUrlMessageApiWebSocket = (window) => (
    checkOriginNonProd(window) === true
        ? getUrlByOrigin(process.env.REACT_APP_NONPROD_URL_MESSAGE_API_WEBSOCKET, window)
        : getUrlByOrigin(process.env.REACT_APP_PROD_URL_MESSAGE_API_WEBSOCKET, window));

// ---------------------------------------------------------------------------------------------------------------------

export const getUserNameToName = (users, startedBy) => {
    if (users?.length === 0) {
        return startedBy;
    }
    return users?.find(x => x.userName === startedBy)?.name || startedBy;
};

export const getUserEmailToName = (users, startedBy) => {
    if (users.length === 0) {
        return startedBy;
    }
    return users.find(x => x.email === startedBy)?.name || startedBy;
};

export const labelsPlant = (vision) => {
    switch (vision) {
        case '1-1':
            return 'Fiasa'
        case '10-10':
            return 'FPT Fire'
        case '12-1':
            return 'FPT Mecanica'
        default:
            return vision
    }
}

export const getLabelsTruckKanban = (shed, companyId, warehouseId) => {
    let vision = `${companyId}-${warehouseId}`
    if (shed === "09" && (vision === VISIONS.Fiasa || vision === VISIONS.Mecanica)) {
        return vision === VISIONS.Fiasa ? "09 - MTP" : "09 - PWT";
    }
    else {
        return shed;
    }
}

export const getPreAllocationArea = (vision) => {
    if (vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD || vision === VISIONS.Fiasa || vision === VISIONS.Jeep) {
        return "%";
    } else {
        return "FILA.%";
    }
};


export const getDefaultPrint = (vision) => {
    let selectedPrint = ""

    if (vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) {
        selectedPrint = ENUMS.ePrintTypes.NotPrint.value
    }
    else if (vision === VISIONS.Fiasa) {
        selectedPrint = ENUMS.ePrintTypes.Logistics.value
    }
    else {
        selectedPrint = ENUMS.ePrintTypes.Click.value
    }

    return selectedPrint
}


export const getCompanyInfo = () => {
    const vision = getVision()

    switch (vision) {
        case VISIONS.Fiasa:
            return { company: "FIASA", plant: PLANTS.Fiasa };

        case VISIONS.PoweTrain:
            return { company: "FPTMEC", plant: PLANTS.PoweTrain };

        case VISIONS.Mecanica:
            return { company: "FPTFIRE", plant: PLANTS.Mecanica };

        case VISIONS.Jeep:
            return { company: "FIAPE", plant: PLANTS.Jeep };

        case VISIONS.Faasa:
            return { company: "FAASA", plant: PLANTS.Faasa };

        case VISIONS.FaasaCKD:
            return { company: "FAASA_CKD", plant: PLANTS.FaasaCKD };
        default:
            return {}
    }
}